module.exports = __webpack_public_path__ + "media/images/modal/Pop-Up_SGR_02-f55018afe7281298e7656d48d19d3f20.png";